import * as vp from 'vopay';

import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

const { api } = vopayApi;

export default function useAccountBranding() {
  const [, setPending] = useDataFetchIndicator();

  const source = axios.CancelToken.source();

  async function fetchAccountBranding(requestParams?: vp.AccountBrandingRequest) {
    try {
      setPending(true);
      const res = await api.fetchPartnerBranding({ Product: vp.BrandingProductType.Portal, ...requestParams }, source);

      return res;
    } finally {
      setPending(false);
    }
  }

  return {
    fetchAccountBranding,
  };
}
